import { defineMessages } from 'react-intl';

export const operator = defineMessages({
  'dt:operator:and': {
    id: 'operator.and.title',
    defaultMessage: 'And',
    value: 'and',
  },
  'dt:operator:or': {
    id: 'operator.or.title',
    defaultMessage: 'Or',
    value: 'or',
  },
});
